import { TTemplate } from "../types/common/templates.types";
import { TComponentName } from "../types/common/components.types";
import { X_STACK_TEMPLATES } from "./containers/XStack";
import { X_BREADCRUMB_TEMPLATES } from "./elements/XBreadcrumb";
import { X_BUTTON_TEMPLATES } from "./elements/XButton";
import { X_FORM_TEMPLATES } from "./elements/XForm";
import { X_ICON_TEMPLATES } from "./elements/XIcon";
import { X_IMAGE_TEMPLATES } from "./elements/XImage";
import { X_MAP_TEMPLATES } from "./elements/XMap";
import { X_RATING_TEMPLATES } from "./elements/XRating";
import { X_TEXT_TEMPLATES } from "./elements/XText";
import { X_PRODUCT_DETAILS_TEMPLATES } from "./containers/XProductDetails";
import { X_CATEGORY_FILTER_TEMPLATES } from "./containers/XCategoryFilter";
import { X_GRID_TEMPLATES } from "./containers/XGrid";
import { X_CAROUSEL_TEMPLATES } from "./containers/XCarousel";

type TMainTemplates = { [componentName in TComponentName]?: TTemplate };

export const TEMPLATES: TMainTemplates = {
  // CONTAINERS
  XStack: X_STACK_TEMPLATES,
  XGrid: X_GRID_TEMPLATES,
  XCarousel: X_CAROUSEL_TEMPLATES,
  XProductDetails: X_PRODUCT_DETAILS_TEMPLATES,
  XCategoryFilter: X_CATEGORY_FILTER_TEMPLATES,

  // ELEMENTS
  XText: X_TEXT_TEMPLATES,
  XButton: X_BUTTON_TEMPLATES,
  XRating: X_RATING_TEMPLATES,
  XMap: X_MAP_TEMPLATES,
  XBreadcrumb: X_BREADCRUMB_TEMPLATES,
  XForm: X_FORM_TEMPLATES,
  XIcon: X_ICON_TEMPLATES,
  XImage: X_IMAGE_TEMPLATES,
};
